export default function GiftIcon2() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.9998 5.8335H15.8332C18.1344 5.8335 19.9998 7.69898 19.9998 10.0002V12.5002H14.9998C13.1589 12.5002 11.6665 11.0078 11.6665 9.16683C11.6665 7.32588 13.1589 5.8335 14.9998 5.8335Z"
                stroke="#F7A40A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.9999 5.8335H24.1666C21.8654 5.8335 19.9999 7.69898 19.9999 10.0002V12.5002H24.9999C26.8409 12.5002 28.3333 11.0078 28.3333 9.16683C28.3333 7.32588 26.8409 5.8335 24.9999 5.8335Z"
                stroke="#F7A40A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.33325 19.1665H31.6666V30.8332C31.6666 32.6741 30.1742 34.1665 28.3333 34.1665H11.6666C9.82564 34.1665 8.33325 32.6741 8.33325 30.8332V19.1665Z"
                stroke="#010101"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M32.4999 12.5H7.49992C6.57944 12.5 5.83325 13.2462 5.83325 14.1667V17.5C5.83325 18.4205 6.57944 19.1667 7.49992 19.1667H32.4999C33.4204 19.1667 34.1666 18.4205 34.1666 17.5V14.1667C34.1666 13.2462 33.4204 12.5 32.4999 12.5Z"
                stroke="#010101"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M20 13L20 33" stroke="#010101" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
